// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3tq-b","type":"styles_type__mOC7f","choices":"styles_choices__1AIIt"};